import m from "./highrise1020.mjs";
import h from "./highrise987.mjs";
function s(o) {
  const {
    heightSmall: r,
    heightMedium: t,
    heightLarge: l,
    textColor1: i,
    errorColor: e,
    warningColor: a,
    lineHeight: n,
    textColor3: g
  } = o;
  return Object.assign(Object.assign({}, m), {
    blankHeightSmall: r,
    blankHeightMedium: t,
    blankHeightLarge: l,
    lineHeight: n,
    labelTextColor: i,
    asteriskColor: e,
    feedbackTextColorError: e,
    feedbackTextColorWarning: a,
    feedbackTextColor: g
  });
}
const f = {
  common: h,
  self: s
};
export {
  f as default,
  s as self
};
